<template>
  <v-dialog v-model="active" persistent width="270">
    <v-card>
      <v-card-title class="headline">请确认：</v-card-title>
      <v-card-text>{{message}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="end(false)">取消</v-btn>
        <v-btn color="primary" flat @click.native="end(true)">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'confirm',
  data () {
    return {
      active: false,
      message: '',
      type: null
    }
  },
  methods: {
    show (message) {
      this.message = message
      this.active = true
      this.type = null
      return new Promise((resolve, reject) => {
        let unwatch = this.$watch('type', (type) => {
          if (type) resolve(type)
          else reject(type)
          unwatch()
        })
      })
    },
    end (type) {
      this.active = false
      this.type = type
    }
  }
}
</script>
